import { observer } from 'mobx-react-lite';
import {
    ActionsPanel_InfoCalloutTextLine1,
    ActionsPanel_InfoCalloutTextLine2,
} from './FilePickerActionsPanelCheckboxView.locstring.json';
import loc from 'owa-localize';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import { Checkbox } from '@fluentui/react/lib/Checkbox';
import { Icon } from '@fluentui/react/lib/Icon';
import showHideActionsPanelCallout from '../../actions/actionsPanelActions/showHideActionsPanelCallout';
import updateSaveUserChoice from '../../actions/actionsPanelActions/updateSaveUserChoice';
import type FilePickerActionsPanelViewState from '../../store/schema/FilePickerActionsPanelViewState';

import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

export interface FilePickerActionsPanelCheckboxViewProps {
    viewState: FilePickerActionsPanelViewState;
    rememberUserChoiceText: string;
}

import styles from './FilePickerActionsPanelCheckboxView.scss';

// This component is responsible for the "remember my choice" cehckbox in the File Picker actions panel.
export default observer(function FilePickerActionsPanelCheckboxView(
    props: FilePickerActionsPanelCheckboxViewProps
) {
    const checkboxIconElement = React.useRef(null);
    const onCheckboxClicked = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        updateSaveUserChoice(props.viewState, checked);
    };
    const getCheckboxIconElement = (element: HTMLElement) => {
        checkboxIconElement.current = element;
    };
    const showActionsPanelCallout = () => {
        showHideActionsPanelCallout(true, props.viewState);
    };
    const hideActionsPanelCallout = () => {
        showHideActionsPanelCallout(false, props.viewState);
    };
    return (
        <div className={styles.infoCheckboxWrapper}>
            <Checkbox
                checked={props.viewState.saveUserChoice}
                label={props.rememberUserChoiceText}
                onChange={onCheckboxClicked}
                className={styles.checkbox}
            />
            <span
                className={styles.infoIconContainer}
                ref={getCheckboxIconElement}
                onMouseOver={showActionsPanelCallout}>
                <Icon className={styles.infoIcon} iconName={ControlIcons.Info} />
            </span>
            {props.viewState.isCalloutVisible && (
                <Callout
                    gapSpace={0}
                    target={checkboxIconElement.current}
                    isBeakVisible={true}
                    beakWidth={10}
                    directionalHint={DirectionalHint.rightCenter}
                    onDismiss={hideActionsPanelCallout}>
                    <div className={styles.checkboxInfoCallout}>
                        <div className={styles.checkboxInfoCalloutLine1}>
                            {loc(ActionsPanel_InfoCalloutTextLine1)}
                        </div>
                        <div>{loc(ActionsPanel_InfoCalloutTextLine2)}</div>
                    </div>
                </Callout>
            )}
        </div>
    );
});
